module.exports = __webpack_public_path__ + "static/media/06.97648040.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/06.jpg
// module id = 375
// module chunks = 0